module.exports = __webpack_public_path__ + "static/media/8_omega.5ea3e9a7.svg";